var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-status-badge",class:[
    `app-status-badge--${_vm.tone}`,
    {
      'app-status-badge--new': _vm.design === 'new',
      'app-status-badge--compact': _vm.compact
    }
  ],style:(_vm.customStyle)},[(_vm.dot)?_c('span',{staticClass:"app-status-badge__dot",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }